import RouteView from "@/layouts/RouteView.vue";
export default {
  path: "/groupIndex",
  name: "groupIndex",
  redirect: "/groupIndex/Index",
  component: RouteView,
  meta: {
    title: "集团首页",
    icon: "wap-home-o",
    isGroup: true,
    showNavBar: true,
  },
  children: [
    {
      path: "/Index",
      name: "groupIndex",
      component: () =>
        import(/* webpackChunkName: "index" */ "@/views/groupIndex/Index.vue"),
      meta: {
        title: "集团首页",
        isGroup: true,
        icon: "wap-home-o",
        showNavBar: true,
      },
    },
    {
      path: "/groupIndex/Business",
      name: "groupBusiness",
      component: () =>
        import(/* webpackChunkName: "index" */ "@/views/groupIndex/Business"),
      meta: {
        title: "运营统计",
        isGroup: true,
        icon: "wap-home-o",
        showNavBar: false,
      },
    },
  ],
};
